// src/guards/permission-guard.jsx
import { Navigate } from "react-router-dom";
import { usePermission } from "@/hooks/use-permissions";

const PermissionGuard = ({ capability, redirectTo = "/dashboard", children }) => {
  const allowed = usePermission(capability);
  if (!allowed) return <Navigate to={redirectTo} replace />;
  return children;
};

export default PermissionGuard;